import { ExternalLookupAdditionalArgumentResponseDTO } from '@/api/base/DTOs';
import { ExternalLookupAdditionalArgument } from '@/typings';

export const adaptExternalLookupAdditionalArgumentResponseToExternalLookupArgument =
  (
    externalLookupAdditionalArgumentResponse: ExternalLookupAdditionalArgumentResponseDTO[],
  ): ExternalLookupAdditionalArgument[] => {
    return externalLookupAdditionalArgumentResponse.map(
      externalLookupAdditionalArgumentResponse => {
        return {
          key: externalLookupAdditionalArgumentResponse.key,
          value: externalLookupAdditionalArgumentResponse.value,
        };
      },
    );
  };
